import { Box, CircularProgress } from "@mui/material";

export default function Loader({ isSmall }: { isSmall?: boolean }) {
  return (
    <Box
      sx={{
        display: "flex",
        ...(isSmall
          ? {}
          : {
              height: "100svh",
              width: "100svw",
            }),
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backdropFilter: "blur(10px)",
      }}
    >
      <CircularProgress size={60} thickness={5} sx={{ color: "white" }} />
    </Box>
  );
}
